import React, { useState } from "react";
import { IOurBrandsProps } from "./OurBrandsProps";
import {
  StyledContainer,
  StyledRow,
  CustomCol,
  LogoLink,
  TextCol,
} from "./OurBrandsHelpers";
import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import SubTitle from "../../global/SubTitle/SubTitle";
import Title3 from "../../global/Title3/Title3";
import { slugify } from "transliteration";

interface IBrandItem {
  id: string;
  logo?: { publicUrl: string };
  summary?: string;
  description?: string;
  name: string;
  teaser: any;
  teaserAlt: any;
  path: string;
}
const OurBrands: React.FC<IOurBrandsProps> = (props) => {
  const brands: Array<any> = [];
  props.brands.map((node) => {
    const _teaserFile = node.relationships.field_teaser_image
      ? node.relationships.field_teaser_image.relationships.field_media_image
          .gatsbyImage
      : null;
    const _teaserAlt = node.relationships.field_teaser_image?.field_media_image
      ? node.relationships.field_teaser_image.field_media_image.alt
      : "";
    const item = {
      id: node.id,
      logo: node.relationships.field_logo
        ? node.relationships.field_logo
        : null,
      summary: node.description ? node.description.summary : null,
      description: node.description ? node.description.processed : null,
      name: node.name,
      teaser: _teaserFile,
      teaserAlt: _teaserAlt,
      path: node.path.alias,
    };
    brands.push(item);
  });
  const [activeItem, setActiveItem] = useState(brands[0]);
  const [index, setIndex] = useState(brands[0].id);

  const handleClick = (item: IBrandItem) => {
    setActiveItem(item);
    setIndex(item.id);
  };
  if (props?.parent_type) {
    return (
      <StyledContainer className="pt-5 pb-5">
        <Container fluid="sm">
          <Row className="mb-3">
            <Col lg={4} className="text-center text-lg-left">
              <SubTitle id={slugify(props.field_subtitle)}>
                {props.field_subtitle}
              </SubTitle>
              <Title3 as="h2" id={slugify(props.field_title)}>
                {props.field_title}
              </Title3>
            </Col>
            <Col lg={{ offset: 1 }}>
              <p
                dangerouslySetInnerHTML={{ __html: props.field_description }}
                className="font-weight-medium description text-left mb-4"
                id="our-brands-description"
              />
            </Col>
          </Row>
          <Row noGutters>
            <Col className="border-top pt-3 pb-3">
              <StyledRow>
                <div className="brand-wrapper">
                  {brands.map((brand: IBrandItem, idx) => {
                    const logo = brand.logo;
                    const path = brand.path;
                    if (logo !== null && path !== null) {
                      return (
                        <CustomCol xs={3} md="auto" key={brand.id}>
                          <LogoLink
                            id={`brand-logo-link-${idx + 1}`}
                            title={brand.name}
                            aria-label={brand.name}
                            className="text-center w-100 p-0"
                            colored={`${
                              index === brand.id || activeItem.id === brand.id
                            }`}
                            variant="link"
                            onClick={() => handleClick(brand)}
                          >
                            <img
                              src={logo?.publicUrl}
                              alt={brand.name}
                              id={`brand-image-${idx + 1}`}
                            />
                          </LogoLink>
                          {activeItem.id === brand.id ? (
                            <div className="bottom-arrow" />
                          ) : null}
                        </CustomCol>
                      );
                    }
                    return null;
                  })}
                </div>
              </StyledRow>
              <hr className="position-relative mb-0 mt-0" />
            </Col>
          </Row>
          <Row style={{ minHeight: "300px" }} noGutters>
            <Col lg={6}>
              {activeItem.teaser && (
                <GatsbyImage
                  image={activeItem.teaser}
                  alt={activeItem.teaserAlt}
                  id="brand-image"
                />
              )}
            </Col>
            <TextCol>
              <div>
                <h3 className="text-center" id={slugify(activeItem.name)}>
                  {activeItem.name}
                </h3>
                <p
                  className="description"
                  id="active-brand-description"
                  dangerouslySetInnerHTML={{ __html: activeItem.description }}
                />
                <div className="d-flex justify-content-center">
                  <Link
                    to={activeItem.path}
                    className="teaser-link"
                    id="explore-brand"
                  >
                    {`Explore Brand`}
                  </Link>
                </div>
              </div>
            </TextCol>
          </Row>
        </Container>
      </StyledContainer>
    );
  }
  return null;
};

export default OurBrands;
